import { Controller } from "@hotwired/stimulus"

// Generic controller for toggling content visibility based on checkbox state
// Usage:
//   data-controller="checkbox-toggle"
//   data-checkbox-toggle-target="checkbox" on the checkbox input
//   data-checkbox-toggle-target="content" on the container to show/hide
//   data-action="change->checkbox-toggle#toggle" on the checkbox
export default class extends Controller {
  static targets = ["checkbox", "content"]

  connect() {
    this.toggle()
  }

  toggle() {
    const isChecked = this.checkboxTarget.checked
    this.contentTarget.style.display = isChecked ? "block" : "none"
    this.contentTarget.querySelectorAll("input, select, textarea").forEach(input => {
      input.disabled = !isChecked
    })
  }
}
